import { EXTERNAL_DEPLOY } from '@/config/constant';
const INTERNAL_HOST_PATTERN = /\.(oa|woa)\.com$/i;
/** 非外网商业化部署，且 host 为 *.oa.com / *.woa.com 的内网部署服务 */
export function isInnerDeploy() {
    if (EXTERNAL_DEPLOY)
        return false;
    return INTERNAL_HOST_PATTERN.test(window.location.hostname);
}
